<template>
  <div id="app">
    <Navigation-admin v-if="userObject.type == 0"/>
    <Navigation v-if="userObject.type != 0" :l="lang"/>
    <div class="container" v-if="showBackButton">
      <div class="row">
        <div class="col-12 d-flex align-items-center justify-content-start">
          <router-link to="/" class="back--btn d-flex align-items-center">
            <mdb-icon icon="home" class="red-text" />
            <span>{{$t("Global.Home")}}</span>
          </router-link>
        </div>
      </div>
    </div>

    <div class="view__wrapper">
      <router-view  :userObject="userObject" :key="lang"/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import NavigationAdmin from  "@/components/partials/NavigationAdmin";
import Navigation from  "@/components/partials/Navigation";
import Header from  "@/components/partials/Header";
import Footer from  "@/components/partials/Footer";
import { authComputed } from '@/helpers/helper.js'
import { mapGetters } from 'vuex'
import NprogressContainer from '../node_modules/vue-nprogress/src/NprogressContainer';
  export default {
    name: 'app',
    components: {
      Navigation,
      NavigationAdmin,
      Header,
      Footer,
    },
    data(){
      return{
        adminmenu: 1,
        logged: false,
        lang: "DE"
      }
    },
    props: {
    },
    computed: {
      ...authComputed,
      showBackButton(){
        let excludedRoutes = ['home','login', 'registerVermieter','registerSuchend','resetPassword', 'nutzerbedingungenVermieter', 'nutzerbedingungenMieter']
        for (let i = 0; i < excludedRoutes.length; i++) {
          if(this.$route.name == excludedRoutes[i]){
            return false
          }
        }
        if(this.userObject.type == 0){
          return false
        }
        return true
      }
    },
    methods:{
      changeLang(){
        this.lang = this.$currentLang.value;
      }
    },
    created() {
      this.lang = this.$currentLang.value;
    }


  };
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');

$image-path: '~@/../mdb/mdbvue/img';
@import '~@/./styles/mdbvue/scss/mdb.scss';
$fa-font-path : "~@fortawesome/fontawesome-free-webfonts/webfonts";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-flow: column;
  height: 100%;
  min-height: 100vh;
  .view__wrapper{
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
}

.list{
  flex-grow: 1;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.back--btn{
  color: #c1002a !important;
  font-size: 32px;
  line-height: 32px;
}
.back--btn span{
  margin-top: 3px;
  font-size: 16px;
  margin-left: 15px;
  font-weight: bold;
}
</style>
